import textConstants from './text-constants';
import settings from './window';
function calculateXPosition() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const xPos = settings.Window.defaultPosition.xPos;
    const bufferedAgentWidth = parseInt(settings.Window.defaultSize.width, 10) + parseInt(xPos, 10);

    const bufferSize = 10;

    if (windowWidth <= (bufferedAgentWidth + bufferSize)) {
        return bufferSize;
    }
    return windowWidth - bufferedAgentWidth + "px";
}

function calculateYPosition() {
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const yPos = settings.Window.defaultPosition.yPos;
    const bufferedAgentHeight = parseInt(settings.Window.defaultSize.height, 10) + parseInt(yPos, 10);

    const bufferSize = 10;

    if (windowHeight <= (bufferedAgentHeight + bufferSize)) {
        return bufferSize;
    }
    return windowHeight - bufferedAgentHeight + "px";
}
export default {
	generateNewSession: {
		GlobalFunctionName: "NITReset",
		actionName: "GenerateNewSession",
		stateSets: [
			{
				stateLocation: "Conversation.SessionId",
				value: "",
			},
			{
				stateLocation: "Conversation.IsActiveSession",
				value: false,
			},
			{
				stateLocation: "History.HistoryMessages",
				value: [],
			},
			{
				stateLocation: "Window.IsMinimized",
				value: true,
			},
			{
				stateLocation: "Window.disableLaunchEvents",
				value: false,
			},
			{
				stateLocation: "Window.Position",
				value: {
					"xPos": calculateXPosition(),
					"yPos": calculateYPosition(),
				},
			},
			{
				stateLocation: "Window.Size",
				value: {
					height: settings.Window.defaultSize.height,
					width: settings.Window.defaultSize.width,
				},
			},
			{
			    stateLocation: "GenerateNewSession.GenerateNewSessionFlag",
				value: false,
			},
			{
				stateLocation: "Window.productPayload",
				value: undefined,
			},
			{
				stateLocation:"Window.advocacyVariables.messagesGiven.birthAdoptChklstUrl",
				value:false,
			},
			{
				stateLocation:"Window.advocacyVariables.messagesGiven.addrChangeChklstUrl",
				value:false,
			},
			{
				stateLocation:"Window.advocacyVariables.messagesGiven.divorceChklstUrl",
				value:false,
			},
			{
				stateLocation:"Window.UDPVars",
				value:undefined,
			},
			{
				stateLocation:"Window.UDPVars",
				value:undefined,
			},
			{
				stateLocation:"WelcomeUser.LaunchPointName",
				value:"",
			},
			{
				stateLocation:"WelcomeUser.LaunchParameter",
				value:"",
			},
			{
				stateLocation:"WelcomeUser.SuppressAction",
				value:[''],
			},
			{
				stateLocation:"WelcomeUser.LaunchType",
				value:"Reactive",
			},
			{
				stateLocation: "Offers",
				value:{
                  "OffersAvailable":[],
				  "OffersProvided":[],
				  "OfferData":[]
				},
			}
		],
	},
    responseMap: {
        messageSourceName: "responseMap",
	},
	outputMasking: {
		messageSourceName:"udpData",
	},
	initializationData: {
		messageSourceName:"initializationData",
		accessKeyMessageSourceName:"accessKeyData",
	},
};


// WEBPACK FOOTER //
// ./settings/generate-new-session-settings.ts